import { Link } from "react-router-dom";
import { Store, Rocket, ArrowRight, CheckCircle2 } from "lucide-react";

const BENEFITS = [
  "Mini-site local + CRM offerts",
  "Offres illimitées, sans commission",
  "Référencement Google & demandes de devis",
];

// Bande de conversion pro (bleu nuit + accents orange) : offre Fondateur 0 € / 12 mois.
export default function ProSpaceConversion() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12" data-testid="pro-conversion-section">
      <div className="relative overflow-hidden rounded-3xl bg-[#172A3A] text-white p-7 md:p-12">
        <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-[#E05638]/20 blur-3xl" aria-hidden="true" />
        <div className="relative grid lg:grid-cols-2 gap-8 items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-[#E05638]/15 border border-[#E05638]/30 px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-[#E05638]">
              <Rocket size={13} /> Offre Fondateur
            </span>
            <h2 className="mt-4 font-heading text-2xl lg:text-3xl font-extrabold leading-tight">
              Commerçant ou artisan ? <span className="text-[#E05638]">0 € pendant 12 mois.</span>
            </h2>
            <p className="mt-3 text-sm md:text-base text-white/75 max-w-lg">
              Rejoignez la première plateforme 100 % locale d'Eure-et-Loir. Créez votre espace professionnel gratuitement et développez votre visibilité auprès des habitants.
            </p>
            <ul className="mt-5 space-y-2">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-center gap-2 text-sm font-medium text-white/90">
                  <CheckCircle2 size={16} className="text-[#E05638] shrink-0" /> {b}
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row lg:flex-col gap-3 lg:items-stretch">
            <Link to="/devenir-partenaire" data-testid="pro-create-space-btn" className="flex-1">
              <button className="w-full h-auto min-h-14 btn-shine text-white text-base font-extrabold px-6 py-3 rounded-2xl inline-flex items-center justify-center gap-2 active:scale-[0.98] transition-transform">
                <Store size={20} /> Créer mon espace pro <ArrowRight size={18} />
              </button>
            </Link>
            <Link to="/pour-les-professionnels" data-testid="pro-benefits-btn" className="flex-1">
              <button className="w-full h-auto min-h-14 bg-white/10 hover:bg-white/15 border border-white/20 text-white text-base font-bold px-6 py-3 rounded-2xl inline-flex items-center justify-center gap-2 active:scale-[0.98] transition-all">
                Voir tous les avantages
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
